import { gql } from 'apollo-angular'

import { ORGANIZATION_RESELLER_REQUEST_DETAIL_FIELDS } from '../../fragments/organization-reseller-request.fragment'

export const GET_ORGANIZATION_RESELLER_REQUEST_BY_ID = gql`
  query GetOrganizationResellerRequestById($id: Int!) {
    OrganizationResellerRequest(id: $id) {
      ...OrganizationResellerRequestDetailFields
    }
  }
  ${ORGANIZATION_RESELLER_REQUEST_DETAIL_FIELDS}
`
